<template>
  <div id="app">
    <router-view v-if="authenticated" />
  </div>
</template>
<script>
  import { initialize, isAuthenticated, login, logout } from '@/keycloak'
  import { authenticationService } from '@/services'

  export default {
    data () {
      return {
        authenticated: isAuthenticated()
      }
    },
    async created () {
      const setAuthenticated = (x) => this.authenticated = x

      await authenticationService.getAuthenticationConfiguration()
        .then(initialize)

      login()
        .then(setAuthenticated)
        .catch(logout)
    }
  }
</script>
<style lang="scss">
  @import "assets/styles";
  @import "~codefabrik-gui-vue/src/assets/styles";
  @import "~@fortawesome/fontawesome-free/css/all.css";

  html, body, #app {
    min-height: 100vh;
  }

  #app {
    background: #fcfafa;
  }

  hr {
    background-color: #e6e6e6;
  }
</style>
